var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[(_vm.isInnerLink)?_c('router-view',{key:_vm.key},[_c('div',{attrs:{"slot":"source"},slot:"source"},[_c('breadcrumb')],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }